import i18n from '../../i18n/i18n';

export const TABS = {
    communication: {
        key: 'communication',
        label: 'communication',
    },
    claimDetails: {
        key: 'claimDetails',
        label: 'claimForm',
    },
    documents: {
        key: 'documents',
        label: 'documents',
    },
};

export const BANK_DETAILS_TAB = {
    key: 'bankDetails',
    label: 'Bank Details',
};

export const SURVEY_TAB = {
    key: 'survey',
    label: 'Survey',
};
